import ServerRequestUtil from '../utils/ServerRequestUtil';
import AuthUtil from '../utils/AuthUtil';

export default new class {

    constructor() {
        this.STATUSES = {
            NOT_UPLOADED: '0',
            UPLOADED: '1',
            APPROVED: '2',
            REJECTED: '3',
            RE_UPLOADED: '4',
        };
        this.TYPES = {
            TYPE_PASSPORT: 0,
            TYPE_DRIVER_LICENSE: 1,
            TYPE_ID_CARD: 2
        }
    }

    uploadKyc(data) {
        
        let formData = new FormData();
        for(let key in data) {
            if(data.hasOwnProperty(key)){
                if (typeof data[key] === 'object') {
                    Object.keys(data[key]).forEach(subKey => {
                        if (data[key][subKey]) formData.append(`${key}[${subKey}]`, data[key][subKey]);
                    });
                } else {
                     formData.append(key, data[key]);
                }
            }
        }
        
        if (data.type == this.TYPES.TYPE_PASSPORT || data.type == this.TYPES.TYPE_ID_CARD) {
            formData.delete('files[file2]');
        }
        
        return ServerRequestUtil.post('/api/app/kyc/upload', formData);
    }

    getStatus() {
        return ServerRequestUtil.get('/api/app/kyc/get');
    }

}
